import React, { useState } from "react";
import { Box } from "@mui/material";
import { StriimTypography } from "@striim/striim-ui";
import { useReactHeader } from "src/hooks/useReactHeader";
import defaultMcpTokenService, { McpTokenService, McpTokenResult } from "./services/mcp-token-service";
import McpPageHeader from "./components/mcp-page-header/mcp-page-header";
import TokenGeneratorPanel from "./components/token-generator-panel/token-generator-panel";
import TokenHeroBox from "./components/token-hero-box/token-hero-box";
import styles from "./striim-mcp-page.styles";

interface StriimMcpPageProps {
    mcpTokenService?: McpTokenService;
}

const StriimMcpPage: React.FC<StriimMcpPageProps> = ({ mcpTokenService = defaultMcpTokenService }) => {
    const [token, setToken] = useState<McpTokenResult | null>(null);
    const endpoint = token?.mcpUrl ?? `http://${window.location.hostname}:9080/mcp`;

    return (
        <Box sx={styles.pageContent}>
            <McpPageHeader endpoint={endpoint} />

            <Box sx={styles.cards}>
                <TokenGeneratorPanel mcpTokenService={mcpTokenService} onTokenGenerated={setToken} />
                <TokenHeroBox token={token} />
            </Box>

            <StriimTypography variant="caption" sx={styles.docsCaption}>
                See the Striim documentation for <i>Striim MCP Server</i>.
            </StriimTypography>
        </Box>
    );
};

export const StriimMcpWrapper: React.FC<StriimMcpPageProps> = props => {
    useReactHeader({ title: "Striim MCP" });

    return (
        <Box sx={styles.gridContainer}>
            <StriimMcpPage {...props} />
        </Box>
    );
};

export default StriimMcpPage;
